import React, { ReactNode, useContext, useEffect } from 'react'

import { useApp } from './AppStore'
import { getUser } from '@/api/post'

export interface SearchBarProps {
  id: number
  key: number
  value: string
  label: string
  name: string
}

interface HomeContextInterface {}

export const HomeContext = React.createContext<HomeContextInterface>(
  {} as HomeContextInterface
)

interface HomeProviderProps {
  children: ReactNode
}

const HomeProvider = ({ children }: HomeProviderProps) => {
  const { setUser, setIsLoading } = useApp()
  const userLocalStorage = localStorage.getItem('cognito:user')
  useEffect(() => {
    async function fetchData() {
      setIsLoading(true)
      try {
        let userData
        if (userLocalStorage && JSON.stringify(userLocalStorage) !== '{}') {
          userData = JSON.parse(userLocalStorage)
        }
        if (userData?.email) {
          const response = await getUser({
            email: userData.email,
          })
          const data = {
            userId: response.user.id,
            email: response.user.email,
            userName: response.user.name,
            lastName: '',
            pn: response.user.pn,
            login: response.user.name,
            domain: response.user.network_login,
            areaId: '',
            isAdmin: response.user.administrator ?? false,
            isEnabled: response.user.active ?? false,
            userPosition: response.user.position,
            permissions: response.user.permissions,
            hasSignature: response.user.hasSignature,
          }

          setUser(data)
        }
      } catch (error) {
        console.error('Error fetching initial data:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [])

  return <HomeContext.Provider value={{}}>{children}</HomeContext.Provider>
}

function useHome(): HomeContextInterface {
  return useContext(HomeContext)
}

export { HomeProvider, useHome }
